import(/* webpackMode: "eager" */ "/vercel/path0/app/(root)/page.jsx");
